import { NBS_API_GET_CHATS_SUCCESS, NBS_API_BLOCK_USER_SUCCESS, NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS } from '../../constants/actions';

const initialState = [];

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_CHATS_SUCCESS:
      const currentState = action.silent ? [] : [...state];
      const { chats } = action.response;
      if (chats.length > 0) {
        for (let user of chats) {
          if (user.sent_total > 0) {
            currentState.push(user);
          }
        }
        currentState.sort((a, b) => a.sent_last > b.sent_last ? -1 : 1);
      }

      return currentState;
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state];
      const newUsers = currentUsers.filter(user => user.user_id !== action.userId);
      return newUsers;
    default:
      return state;
  }
}
